import { aStarTitles } from './constants';

/**
 * 구매 딜 및 옵션 정보 영역 HTML을 반환
 */
const getDealInfoHtml = () =>
  `<div class="review_write_box">
        <h3 class="blind">구매상품 정보</h3>
        <div class="deal_option_info">
            <div class="deal_option_thumb">
                <span class="_reviewImage deal_option_img"></span>
            </div>
            <div class="deal_option_text">
                <strong class="_reviewWriteTitle deal_option_title"></strong>
                ${/* [D] 구매 옵션 클릭시 펼침, open 클래스 추가 --> */ ''}
                <div data-role="reviewWriteOption" class="deal_option_box">
                    <ul class="_buyOption deal_option_list"></ul>
                    ${/* <!-- [D] 구매 옵션이 2개 이상부터 버튼 노출 --> */ ''}
                    <button type="button" role="reviewWriteMore" class="btn_open" aria-label="구매옵션 펼쳐보기">
                        <span class="blind">구매옵션 펼쳐보기</span>
                        <!--<span class="blind">구매옵션 접기</span>-->
                        <svg width="11px" height="6px" viewBox="0 0 11 6" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="ico_open_arrow"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="pc_btn_open_op" fill="#979EA7" fill-rule="nonzero"><polygon transform="translate(5.500000, 3.000000) rotate(-180.000000) translate(-5.500000, -3.000000) " points="5.5 1.4 0.723 6 0 5.3 4.777 0.7 5.5 0 11 5.3 10.277 6"></polygon></g></g></svg>
                    </button>
                </div>
            </div>
        </div>
    </div>`;

/**
 * 별점 컴포넌트 HTML을 반환
 * @param {String} sId
 * @param {Number} nGpoint
 */
const getRateScoreStarHtml = (sId, nGpoint) => {
  let sHtml = '';

  for (let i = 1; i <= 5; i += 1) {
    sHtml += `<button type="button" class="btn_star_score ${sId} ${
      nGpoint >= i ? 'on' : ''
    }" value="${i}"></button>`;
  }

  return sHtml;
};

/**
 * 평점 정보 영역 HTML을 반환
 */
const getRateScoreHtml = (sDealType, dealGpoint = 0, deliveryGpoint = 0) =>
  `<h3 class="blind">구매상품 평점</h3>
    <div class="star_score">
        <div class="star_score_box">
            <strong class="review_write_title type2">상품 만족도</strong>
            <div class="star_score_bind">
                ${getRateScoreStarHtml('_saStar', dealGpoint)}
                <span class="star_score_text _saTitle ${
                  dealGpoint !== 0 ? 'on' : ''
                }">${aStarTitles[dealGpoint]}</span>
            </div>
        </div>
        <div class="star_score_box" style="${
          sDealType === 'DELIVERY' ? '' : 'display:none;'
        }">
            <strong class="review_write_title type2">배송 만족도</strong>
            <div class="star_score_bind">
                ${getRateScoreStarHtml('_deStar', deliveryGpoint)}
                <span class="star_score_text _deTitle ${
                  deliveryGpoint !== 0 ? 'on' : ''
                }">${aStarTitles[deliveryGpoint]}</span>
            </div>
        </div>
    </div>`;

/**
 * 상품 평가하기 영역 HTML을 반환
 * @param {*} sDealType
 * @param {*} nDealGpoint
 * @param {*} nDeliveryGpoint
 */
const getEvaluateReviewAreaHtml = (sDealType, nDealGpoint, nDeliveryGpoint) =>
  `<div class="review_write_input">
        <h2 class="review_write_title type2">상품 평가하기</h2>
        <div class="review_write_rate">
            ${
              /* 별점 매기기 */
              getRateScoreHtml(sDealType, nDealGpoint, nDeliveryGpoint)
            }
            ${/* 상품 평가항목 */ ''}
            <section id="_reviewSurvey" class="review_input" style="display:none;">
                <h1 class="blind">상품 평가항목</h1>
            </section>
        </div>
    </div>`;

/**
 * word 의 마지막 글자가 받침을 가지는지 여부 확인
 * @param sWord
 * @returns {boolean}
 */
function hasFinalConsonant(sWord) {
  return (sWord.charCodeAt(sWord.length - 1) - 0xac00) % 28 > 0;
}

/**
 * 키워드를 기반으로 유저뷰에 출력되는 문구 조회
 * : 유저뷰에는 ‘실제 (질문키워드)는(은) 어떤가요?’로 텍스트가 조합되어 출력
 * @param {string} sKeyword 질문 키워드
 * @returns {string}
 */
function getPreviewQuestionHtml(sKeyword) {
  if (!sKeyword) {
    return '';
  }

  let sPostposition = '는';
  if (hasFinalConsonant(sKeyword)) {
    sPostposition = '은';
  }

  return `실제 <span class='notice'>${sKeyword}</span>${sPostposition} 어떤가요?`;
}

/**
 * 상품 평가 입력 radio HTML을 반환
 * @param {*} sName
 * @param {*} nQuestionIdx
 * @param {*} sText
 * @param {*} nValue
 * @param {*} bIsSelected
 */
const getReviewInputHtml = (sName, nQuestionIdx, sText, nValue, bIsSelected) =>
  // [D] 선택시 checked, 비활성화 시 disabled
  `<li class="review_input_item">
        <div class="review_input_bind">
            <input type="radio" name="${sName}" id="${nValue}" data-question-idx="${nQuestionIdx}" value="${nValue}" class="_surveyItem review_input_type" ${
    bIsSelected ? 'checked' : ''
  }>
            <label for="${nValue}" class="review_input_label">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" class="ico_circle_input"><g fill="none" fill-rule="evenodd"><circle cx="15" cy="15" r="15" fill="#DFE2E6"></circle><path stroke="#FFF" stroke-width="2" d="M9.375 14.094l4.788 4.656 7.712-7.5" opacity=".5"></path></g></svg>
                <span class="text">${sText}</span>
            </label>
        </div>
    </li>`;

/**
 * 상품 평가 항목 HTML
 */
const getRateInputHtml = (aReviewSurveyItems, htRenderData) => {
  let sHtml = '';

  // 딜의 설문조사 항목을 추가
  Object.keys(aReviewSurveyItems).forEach(idx => {
    sHtml += `<div class="review_input_area">
                <span class="review_write_title type2" data-question-idx="${
                  aReviewSurveyItems[idx].reviewItem.reviewSurveyItemNo
                }">
                    ${getPreviewQuestionHtml(
                      aReviewSurveyItems[idx].reviewItem.keyword
                    )}
                </span>
                <ul class="review_input_list">`;

    // 설문조사 답변 항목을 추가
    Object.keys(aReviewSurveyItems[idx].selections).forEach(selectionIdx => {
      // 리뷰 수정의 경우 선택된 답변 항목을 표시하기 위한 값
      let bIsSelected = false;

      if (htRenderData && htRenderData.reviewSurveyList) {
        bIsSelected = htRenderData.reviewSurveyList.some(
          elem =>
            elem.reviewSurveyItemSelectionNo ===
            aReviewSurveyItems[idx].selections[selectionIdx]
              .reviewSurveyItemSelectionNo
        );
      }

      sHtml += getReviewInputHtml(
        aReviewSurveyItems[idx].reviewItem.keyword,
        aReviewSurveyItems[idx].reviewItem.reviewSurveyItemNo,
        aReviewSurveyItems[idx].selections[selectionIdx].selection,
        aReviewSurveyItems[idx].selections[selectionIdx]
          .reviewSurveyItemSelectionNo,
        bIsSelected
      );
    });

    sHtml += '</ul></div>';
  });

  return sHtml;
};

/**
 *
 * @param {String} text
 */
const getTextInputAreaHtml = contents =>
  `<div class="review_write_header">
        <h1 class="review_write_title type2">리뷰 작성하기</h1>
        <span class="text_count"><em>${0}</em>/600</span>
        <button type="button" role="showWritePop" class="btn_notice"><svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="ico_review_info"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="ico_review_info"><g><circle id="Oval" stroke="#959DA6" fill="#FFFFFF" cx="7" cy="7" r="6.5"></circle><g id="Group" transform="translate(6.500000, 3.500000)" fill="#959DA6"><rect id="Rectangle" x="0" y="0" width="1" height="5"></rect><rect id="Rectangle-Copy-2" x="0" y="6" width="1" height="1"></rect></g></g></g></g></svg>작성시 유의사항</button>
    </div>
    ${/* 구매 후기 텍스트 내용 입력 */ ''}
    <div class="review_write_textarea">
        ${
          /* [D] textarea 포커스 일 때, on 클래스 추가 (ios에서 placholder 줄바꿈 되지 않아 review_write_placeholder 생성) */ ''
        }
        <textarea id="reviewContents" title="구매후기 작성" name="reviewContents" maxlength="600">${contents}</textarea>
        ${/* 후기 작성하기 : placeholder */ ''}
        <div class="review_write_placeholder">
            <ul class="placeholder_list">
                <li class="placeholder_item"><span class="text">리뷰는 최소 10자 이상 입력해 주세요.<br>사진은 최대 4장까지 등록 가능합니다.</span></li>
                <li class="placeholder_item"><span class="text">상품과 무관하거나 스팸, 불법적인 내용의 리뷰는 통보없이 비노출 처리될 수 있습니다.</span></li>
            </ul>
        </div>
    </div>`;

/**
 *
 * @param {String} text
 */
const getFileInputAreaHtml = (hasImage, imageInfo, oImageUpload) =>
  `<div class="review_write_header">
        <h2 class="review_write_title type2">이미지 등록</h2>
        <span class="text_count"><span class="cnt">${
          hasImage === true && imageInfo ? imageInfo.image.length : 0
        }</span>/4</span>
    </div>
    <div class="review_write_image">
        <form method="post" id="_reviewImageUploadForm" enctype="multipart/form-data">
            <ul id="_uploadImageList" class="review_write_list">
                ${
                  hasImage === true && imageInfo
                    ? imageInfo.image
                        .map(sImage => oImageUpload.renderImage(sImage))
                        .join('')
                    : ''
                }
                <li id="_uploadRLoading" class="review_write_item" style="display:none">
                    <div class="img_file_box" style="background-image: url('')">
                        <span class="loading"><span class="blind">이미지 업로드중</span></span>
                    </div>
                </li>
            </ul>
            <div id="_uploadRImage" class="img_file_button">
                ${/* class="input_file"에 비활성화시 disabled 속성 추가 */ ''}
                <input type="file" name="uploadFile" class="input_file" accept="image/*"
                    ${
                      TMON.sDevice === 'PW' ||
                      TMON.sDevice === 'MW' ||
                      TMON.sDevice === 'MA' ||
                      // ios 앱일 경우에는 버전체크 후 multiple 추가
                      // eslint-disable-next-line no-underscore-dangle
                      (TMON.sDevice === 'MI' &&
                        TMON.app._isValidAppVersion('4.8.7'))
                        ? 'multiple'
                        : ''
                    } ${
    hasImage === true && imageInfo && imageInfo.image.length === 4
      ? 'disabled'
      : ''
  }>
                <span class="input_file_text">
                    <svg width="19px" height="16px" viewBox="0 0 19 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="ico_camera"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="ico_camera" stroke="#F27935"><g><path d="M12.5569995,0.5 L6.44300047,0.5 C6.23457819,0.5 6.04801783,0.629286417 5.97472189,0.824741949 L5.34526022,2.5 L2,2.5 C1.17157288,2.5 0.5,3.17157288 0.5,4 L0.5,14 C0.5,14.8284271 1.17157288,15.5 2,15.5 L17,15.5 C17.8284271,15.5 18.5,14.8284271 18.5,14 L18.5,4 C18.5,3.17157288 17.8284271,2.5 17,2.5 L13.6534998,2.5 L13.0251641,0.824438279 C12.9519822,0.629286417 12.7654218,0.5 12.5569995,0.5 Z" id="Combined-Shape"></path><g id="Group-13" transform="translate(6.000000, 5.000000)"><line x1="3.5" y1="-1.13659082e-13" x2="3.5" y2="7" id="Path-4"></line><line x1="7" y1="3.5" x2="2.27318164e-13" y2="3.5" id="Path-4-Copy"></line></g></g></g></g></svg>
                    사진 추가 (<span class="cnt">${
                      hasImage === true && imageInfo
                        ? imageInfo.image.length
                        : '0'
                    }</span>/4)
                </span>
            </div>
        </form>
    </div>`;

const getWriteReviewHtml = (
  sReviewType,
  contents,
  hasImage,
  imageInfo,
  oImageUpload
) =>
  `<section class="review_write_out" ${
    sReviewType === 'S' ? 'style="display:none;"' : ''
  }>
        ${getTextInputAreaHtml(contents)}
        ${getFileInputAreaHtml(hasImage, imageInfo, oImageUpload)}
    </section>`;

const getReviewBenefitAreaHtml = () =>
  `<section class="_reviewWriteInfo review_write_notice">
        <h1 class="review_write_title type2">리뷰 작성시 혜택 안내</h1>
        <ul class="info_dot_list">
            <li class="info_dot_item"><span class="text"><span class="f_bold">일반, 포토리뷰 작성시 <span class="point_color_orange">최초 1회에 한해 적립금 10원 즉시지급</span></span></span></li>
            <li class="info_dot_item"><span class="text">리뷰 작성 적립금은 <span class="f_bold">적립일 기준 <span class="point_color_orange">14일 이내 사용</span></span> 가능</span></li>
            <li class="info_dot_item"><span class="text">리뷰는 상품 <span class="f_bold"><span class="point_color_orange">주문별 작성 가능</span> (단, 동일 상품인 경우 <span class="point_color_orange">1회에 한해 적립금 지급</span>)</span></span></li>
            <li class="info_dot_item"><span class="text">배송상품 : <span class="f_bold">리뷰 작성 후 적립금 즉시 지급</span></span></li>
            <li class="info_dot_item"><span class="text">지역, 티켓, 여행상품 : <span class="f_bold">최소 1회이상 사용완료 후 리뷰 작성 및 적립금 지급</span></span></li>
            <li class="info_dot_item"><span class="text"><span class="f_bold">리뷰 삭제 후 재작성시 적립금 지급되지 않음</span></span></li>
            <li class="info_dot_item"><span class="text"><span class="f_bold">리뷰 작성 후 해당 주문 취소시 지급된 적립금 회수</span></span></li>
            <li class="info_dot_item"><span class="text">당사의 상품 리뷰 운영원칙 및 관련법령에 위반되는 경우 작성자에게 사전 통보 없이 비노출 처리</span></li>
            <li class="info_dot_item"><span class="text"><span class="point_color_orange f_bold">2019년 7월 17일 이후</span> 주문 건부터 적립금 지급</span></li>
            <li class="info_dot_item"><span class="text">0원, 이벤트 상품은 적립금 지급 대상에서 제외</span></li>
        </ul>
        <button type="button" class="btn_review_wide">
            <span class="text">더보기</span>
            <svg width="11px" height="6px" viewBox="0 0 11 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="ico_btn_arrow"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="btn_open" fill="#B7BFC8" fill-rule="nonzero"><polygon transform="translate(5.500000, 3.000000) rotate(-180.000000) translate(-5.500000, -3.000000) " points="5.5 1.4 0.723 6 0 5.3 4.777 0.7 5.5 0 11 5.3 10.277 6"></polygon></g></g></svg>
        </button>
    </section>`;

const getConfirmAreaHtml = bIsModify =>
  `<div class="review_write_btn">
        <button type="button" role="cancel" class="btn_review">취소</button>
        <button type="button" role="register" class="btn_review fill"${
          /* 등록·수정 버튼 이용 불가 시 : disabled 속성 추가 */ ''
        }>${bIsModify ? '수정' : '등록'}</button>
    </div>`;

/**
 * 구매 후기 작성시 유의사항 HTML
 */
const getNotifyPopupHtml = () =>
  `<div role="writePopup" class="write_pop_wrap" style="display: none">
        <article class="write_pop_article">
            <div class="write_pop_header">
                <h4>리뷰 작성시 유의사항</h4>
                <button type="button" role="closeWritePop" class="btn_close" aria-label="레이어 닫기"><svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="ico_x"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="ico_closed_btn" fill="#959DA6"><polygon points="14.293 0 7.5 6.794 0.705 0 -8.8817842e-16 0.706 6.792 7.5 -8.8817842e-16 14.294 0.705 15 7.5 8.206 14.293 15 15 14.294 8.205 7.5 15 0.706"></polygon></g></g></svg></button>
            </div>
            <div class="write_pop_contents">
                <ol class="contents_list">
                    <li>리뷰 내용과 사진은 티몬에서 거래되는 상품의 판촉, 홍보 등을 위하여 복제, 배포, 전송, 전시 등에 이용 될 수 있습니다.</li>
                    <li>리뷰 내용 또는 사진이 아래의 내용에 해당하는 경우에는 작성자에게 통보 없이 비공개 처리되거나 민/형사상의 책임이 따를 수 있습니다.
                        <ul class="contents_list_sub">
                            <li>상품과 관계없는 내용 또는 이미지, 비방, 무의미한 단어반복, 허위의 사실 유포 등 다른 회원 또는 회사의 영업을 방해하는 경우</li>
                            <li>저작권, 초상권 등 타인의 권리 혹은 개인정보(신용카드번호, 전화번호 등)의 침해 우려가 있는 경우</li>
                            <li>특정 성분의 효능에 있어 오해의 소지가 있는 경우</li>
                            <li>기타 관계법령에 위반되는 경우</li>
                        </ul>
                    </li>
                </ol>
            </div>
        </article>
    </div>`;

export {
  getDealInfoHtml,
  getEvaluateReviewAreaHtml,
  getRateInputHtml,
  getWriteReviewHtml,
  getReviewBenefitAreaHtml,
  getConfirmAreaHtml,
  getNotifyPopupHtml,
};
